import {
    animationDurationMs,
    checkedKnobLeftOffset,
    uncheckedKnobLeftOffset,
} from '@/features/ui/inputs/components/Switch/constants'
import {
    Easing,
    useAnimatedReaction,
    useAnimatedStyle,
    useSharedValue,
    withTiming,
} from 'react-native-reanimated'

export const useAnimatedPosition = (checked: boolean) => {
    const offset = useSharedValue(checked ? checkedKnobLeftOffset : uncheckedKnobLeftOffset)

    useAnimatedReaction(
        () => checked,
        () => {
            offset.value = withTiming(checked ? checkedKnobLeftOffset : uncheckedKnobLeftOffset, {
                duration: animationDurationMs,
                easing: Easing.out(Easing.linear),
            })
        }
    )

    return useAnimatedStyle(() => ({
        transform: [{ translateX: offset.value }],
    }))
}
